export enum CardType {
    Product = 'product',
    Situation = 'situation',
    Tool = 'tool',
    Provider = 'provider',
    ThemedArticle = 'themed-article',
    Guide = 'guide',
    Overview = 'overview',
    Generic = 'generic',
    EmployerFrontpage = 'employer-frontpage',
    ProviderFrontpage = 'provider-frontpage',
    PersonFrontPage = 'person-frontpage',
}

export enum CardSize {
    Large = 'large',
    Mini = 'mini',
    Micro = 'micro',
}
